import React from "react";
import CodeEditor from "../CodeEditor";
import Wrapper from "../Wrapper";
import Button, { ButtonGroup } from "../Button";
import classNames from 'classnames';
import FontIcon, { SolidIcons } from "../FontIcon";
import { Icon, Tooltip } from "antd";
import i18n from '../../../../../constants/initLng';
import beautify from 'js-beautify';
import './EmailEditor.less';
import Modal from "../Modal";

const EmailEditor = (props) => {
    const {
        t,
        fullscreen,
        title,
        onChange,
        value,
        ...restProps
    } = props;
    const [isFullscreen, setFullscreen] = React.useState(false);
    const [isVertical, setVerticalView] = React.useState(true);
    const [isHideReview, setHideReview] = React.useState(false);
    const [isShowPageReview, setShowPageReview] = React.useState(false);

    const formatCode = () => {
        return onChange(beautify.html_beautify(value))
    }
    const renderToolbarButton = (icon, tooltip, onClick = (e) => { }, tooltipPlacement, isDisabled = false) => {
        return (
            <Tooltip title={tooltip} placement={tooltipPlacement || "bottom"}>
                <Button type="default" disabled={isDisabled} onClick={onClick}>
                    <Icon component={() => <FontIcon icon={SolidIcons[icon]}></FontIcon>} />
                </Button>
            </Tooltip>
        )
    }

    return (
        <Wrapper className={classNames("hms-email-editor", { fullscreen: isFullscreen })}>
            <ButtonGroup className="toolbar-section" >
                {renderToolbarButton('faIndent', i18n.t(`action.formatCode`), formatCode, 'bottomLeft')}
                {renderToolbarButton(isVertical ? 'faWindowMaximize' : 'faColumns',
                    (isVertical ? i18n.t(`action.horizontal`) : i18n.t(`action.vertical`)),
                    () => setVerticalView(!isVertical), 'bottomLeft')}
                {renderToolbarButton(isHideReview ? 'faEye' : 'faEyeSlash',
                    (isHideReview ? i18n.t(`action.showReview`) : i18n.t(`action.hideReview`)),
                    () => setHideReview(!isHideReview))}
                <Wrapper className="expand-section"></Wrapper>
                {
                    renderToolbarButton('faSearch', i18n.t(`action.pageReview`), () => setShowPageReview(true), 'bottomRight', isShowPageReview)
                }
                {renderToolbarButton(isFullscreen ? 'faCompress' : 'faExpand',
                    (isFullscreen ? i18n.t(`action.minimize`) : i18n.t(`action.maximize`)),
                    () => setFullscreen(!isFullscreen), 'bottomRight')}
            </ButtonGroup>
            <Wrapper className={classNames("content-section", { horizontal: !isVertical })}>
                <Wrapper className="email-edit-section">
                    <CodeEditor {...restProps}
                        theme={'monokai'}
                        value={value}
                        height={isFullscreen && isVertical ? '100%' : '450px'}
                        onChange={onChange}
                        className={restProps.className} />
                </Wrapper>
                {!isHideReview &&
                    <Wrapper className="email-review-section">
                        <iframe title={title} srcDoc={value} ></iframe>
                    </Wrapper>
                }
            </Wrapper>
            <Modal
                title={title}
                visible={isShowPageReview}
                width="95%"
                bodyStyle={{ margin: 0, padding: 0 }}
                destroyOnClose={true}
                footer={null}
                centered={true}
                onCancel={() => setShowPageReview(false)}
            >
                <iframe className="email-page-review-section" title={title} srcDoc={value} ></iframe>
            </Modal>
        </Wrapper>
    )
};

export default EmailEditor;